export default __webpack_public_path__ + "static/media/programWork.5a1973a6.svg";